import { useFetch } from "@/hooks/useFetch";
import { fetchTimesheetEntry } from "@/modules/timesheet/api";

import { TIMESHEET_QUERY_KEYS } from "components/timesheet/query-keys";
import { useParams } from "react-router-dom";
import TimesheetReviewForm from "./components/form";
import { TimesheetReviewSkeleton } from "./loader";
import { ViewField } from "@/components/field";
import { RenderProfile } from "components/render-profile";
import { EmptySection1 } from "components/empty";
import { formatDateForDisplay, formatDateToDMY } from "@/lib/utils";
import { formatDateForTimesheet } from "../utils";

export default function TimesheetReview() {
  const { timesheetId } = useParams();
  const {
    data: entryData,
    isLoading,
    isError,
    error,
  } = useFetch({
    queryKey: [TIMESHEET_QUERY_KEYS.TIMESHEET_REVIEW, timesheetId],
    queryFn: () => fetchTimesheetEntry({ timesheetId }),
  });

  if (isLoading) {
    return <TimesheetReviewSkeleton />;
  }

  if (isError) {
    if (error.response.status === 403) return <EmptySection1 />;
    console.log(error);
    return <div>error loading data</div>;
  }

  return (
    <div className="p-6 grid md:grid-cols-10 grid-cols-1  md:h-full gap-4 md:gap-6 flex-1">
      <div className="md:col-span-4 flex flex-col gap-4 md:border-r md:border-solid ">
        <ViewField value={<RenderProfile user={entryData.employee} />} />
        <ViewField label="Date" value={formatDateForDisplay(entryData.date)} />
        <ViewField label="Project" value={entryData.project.name} />

        <ViewField label="Job" value={entryData.job.name} />

        <ViewField label="Milestone" value={entryData.milestone?.name} />
        <ViewField label="Tag" value={entryData.tag?.label} />

        <ViewField label="Hours" value={entryData.logged_hours} />
        <TimesheetReviewForm entryData={entryData} date={entryData.date} />
      </div>
      <div className="md:col-span-6">
        <ViewField
          label="Description"
          value={entryData?.description}
          className={"whitespace-pre-wrap"}
        />
      </div>
    </div>
  );
}
